<div class="wrap">
  <form [formGroup]="addUserForm" (ngSubmit)="onSubmit()" *ngIf="!confirmAdd">
    <h2>Ajouer un utilisateur</h2>

    <div class="info_user">
      <ion-avatar>
        <img [src]=" imgUserDefault" />
      </ion-avatar>
      <div><span [style.margin-right.px]="10">{{addUserForm.get('lastname').value}}</span>
        <span>{{addUserForm.get('firstname').value}}</span>
      </div>
    </div>
    <div class="username_choice_picture">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>{{'addUser.username.label' | translate}}</mat-label>
        <input matInput formControlName="username" (input)="isInactive($event.target.value)">
      </mat-form-field>
      <div class="choice_picture">
        <fa-icon [icon]="faCamera"></fa-icon>
        <input matinput type="file" class="input_picture" formControlName="imgUser"
          (input)="isInactive($event.target.value)" (change)="convertImage($event)">
      </div>
    </div>
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Nom</mat-label>
      <input matInput formControlName="lastname" (input)="isInactive($event.target.value)">
    </mat-form-field>
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Prénom</mat-label>
      <input matInput formControlName="firstname" (input)="isInactive($event.target.value)">
    </mat-form-field>
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>{{'addUser.password.label' | translate}}</mat-label>
      <input matInput formControlName="password" (input)="isInactive($event.target.value)">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{'addUser.role.label' | translate}}</mat-label>
      <mat-select formControlName="role">
        <mat-option *ngFor="let r of roles" [value]="r.name">{{r.description}}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="steps" *ngIf="addUserForm.get('role').value !== 'admin'">
      <mat-checkbox [color]="color" *ngFor="let s of steps" (click)="addOrRemoveStep(s)">{{s.description}}</mat-checkbox>
    </div>

    <div class="btn_action">
      <button class="canceled" type="button" (click)="dialog.closeAll()">Annuler</button>
      <button type=" submit" [ngClass]="{isInactive: inactive, isActive: !inactive }" [mat-dialog-close]="userAdd"
        [disabled]="inactive">
        Ajouter</button>
    </div>
  </form>


  <div class="confirm" *ngIf="confirmAdd">
    <div class="validation_mail">
      <div class="check">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
    <h4>{{'addUser.confirmAdd.label' | translate}}</h4>
  </div>
</div>